var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-style-template"},[_c('div',{ref:"preview"})])
}
var staticRenderFns = []

export { render, staticRenderFns }